module.exports = __webpack_public_path__ + "static/media/ico_insight.dc3b4189.svg";